import React from 'react';
import * as FiIcons from 'react-icons/fi';
import { FiAlertTriangle } from 'react-icons/fi';

const SafeIcon = ({ icon, name, ...props }) => {
  let IconComponent;
  try {
    // If icon object is passed directly, use it.
    // Otherwise try to look it up by name in FiIcons
    IconComponent = icon || (name && FiIcons[`Fi${name}`]);
  } catch (e) {
    console.warn("Icon load error:", e);
    IconComponent = null;
  }
  
  // Fallback if no valid component found
  if (!IconComponent) {
    return <FiAlertTriangle {...props} className={`text-yellow-500 ${props.className || ''}`} />;
  }

  return React.createElement(IconComponent, props);
};

export default SafeIcon;